import React from 'react'
import Layout from '../layouts'
import { Link, graphql } from 'gatsby'
import Navigation from '../components/hero/index.js'
import Contact from '../components/contact/contact.js'
import Partners from '../components/partners/index.js'
// import store from '../images/store.jpg'
// import truck from '../images/truck.jpg'
// import psa from '../images/psa.jpg'
import mediakit from '../images/media-kit.jpg'
// import mobilekit from '../images/mobile-kit.jpg'
// import trimaxmediakit from '../../static/assets/Trimex Outdoor Media Kit 2024 Timar.pdf'
// import trimaxmobilekit from '../../static/assets/trimex-outdoor-mobile-tours.pdf'
import trimexmediakit2026 from '../../static/assets/Trimex-Outdoor-Media-Kit-2026.pdf'

import { GiTacos, GiFoodTruck } from 'react-icons/gi'
import { IoNewspaperSharp } from 'react-icons/io5'
import {
  FaStore,
  FaTruck,
  FaIceCream,
  FaPizzaSlice,
  FaMoneyBill,
} from 'react-icons/fa'

function importAll(r) {
  return r.keys().map(r)
}

const images = importAll(
  require.context(
    '../images/hero',
    false,
    /\.(png|jpe?g)$/ // png, jpg, jpeg
  )
)

class IndexPage extends React.Component {
  render() {
    return (
      <Layout>
        <div id="hero" className="container" style={{ maxWidth: '1800px' }}>
          <div className="carousel-container">
            <Navigation images={images} />
          </div>
        </div>
        <div id="index" className="mt-10">
          <section id="title">
            <div className="container">
              <div className="row">
                <div className="col text-center">
                  <h1
                    className="heading-title tagline"
                    style={{ textTransform: 'none' }}
                  >
                    "500,000+ Storefronts, 2,000+ trucks. One unstoppable
                    network."
                  </h1>
                </div>
              </div>
            </div>
          </section>

          <section id="services" className="">
            <h2 className="section-title text-center mb-5">Our Media Menu</h2>
            <div class="container">
              <div class="row text-center">
                <div class="col-sm-6 col-lg-3 mb-5">
                  <Link
                    title="Storefront Advertising"
                    to="/storefront-advertising"
                  >
                    <div class="mb-3 media-icon bg-orange mx-auto">
                      <FaStore className="icon" />
                    </div>
                  </Link>
                  <p class="font-weight-bold text-uppercase">
                    STOREFRONT INSTORE PLACE BASED BILLBOARDS
                  </p>
                </div>
                <div class="col-sm-6 col-lg-3 mb-5">
                  <Link
                    title="Lunch Truck Advertising"
                    to="/lunch-truck-advertising"
                  >
                    <div class="mb-3 media-icon bg-dark-green mx-auto">
                      <FaTruck className="icon" />
                    </div>
                  </Link>
                  <p class="font-weight-bold text-uppercase">
                    LUNCH TRUCK ADVERTISING INDUSTRIAL
                  </p>
                </div>
                <div class="col-sm-6 col-lg-3 mb-5">
                  <Link
                    title="Street Food Trucks, Trailers & Food Pavilions"
                    to="/street-food-trucks-trailers-food-pavilions"
                  >
                    <div class="mb-3 media-icon bg-light-blue mx-auto">
                      <GiTacos className="icon" />
                    </div>
                  </Link>
                  <p class="font-weight-bold text-uppercase">
                    STREET FOOD TRUCKS, TRAILERS AND FOOD PAVILIONS
                  </p>
                </div>
                <div class="col-sm-6 col-lg-3 mb-5">
                  <Link
                    title="Ice Cream Trucks, Paleta Carts, Fruit Carts"
                    to="/ice-cream-trucks-paleta-carts-fruit-carts"
                  >
                    <div class="mb-3 media-icon bg-purple mx-auto">
                      <FaIceCream className="icon" />
                    </div>
                  </Link>
                  <p class="font-weight-bold text-uppercase">
                    ICE CREAM TRUCKS PALETA CARTS FRUIT CARTS
                  </p>
                </div>
                <div class="col-sm-6 col-lg-3 mb-5">
                  <Link
                    title="Pizza Restaurant Box Topper Ads"
                    to="/pizza-restaurant-box-topper-ads"
                  >
                    <div class="mb-3 media-icon bg-light-green mx-auto">
                      <FaPizzaSlice className="icon" />
                    </div>
                  </Link>
                  <p class="font-weight-bold text-uppercase">
                    PIZZA RESTAURANT BOX TOPPER ADS
                  </p>
                </div>
                <div class="col-sm-6 col-lg-3 mb-5">
                  <Link
                    title="Check Cashing Envelopes & Jackets"
                    to="/check-cashing-envelopes-jackets"
                  >
                    <div class="mb-3 media-icon bg-bright-orange mx-auto">
                      <FaMoneyBill className="icon" />
                    </div>
                  </Link>
                  <p class="font-weight-bold text-uppercase">
                    CHECK CASHING ENVELOPES AND JACKETS
                  </p>
                </div>
                <div class="col-sm-6 col-lg-3 mb-5">
                  <Link title="Wild Posters" to="/wild-posters">
                    <div class="mb-3 media-icon bg-red mx-auto">
                      <IoNewspaperSharp className="icon" />
                    </div>
                  </Link>
                  <p class="font-weight-bold text-uppercase">WILD POSTERS</p>
                </div>
                <div class="col-sm-6 col-lg-3 mb-5">
                  <Link title="Mobile Tours" to="/mobile-tour">
                    <div class="mb-3 media-icon bg-grayish-blue mx-auto">
                      <GiFoodTruck className="icon" />
                    </div>
                  </Link>
                  <p class="font-weight-bold text-uppercase">MOBILE TOURS</p>
                </div>
              </div>
            </div>
          </section>
          <section id="media-kit">
            <h2 className="section-title text-center">Media Kit 2026</h2>
            <div className="container">
              {/* <img src={mediakit} className="img-fluid" alt="mediakit" /> */}
              <div className="d-flex justify-content-center">
                <a
                  class="link-btn-green"
                  href={trimexmediakit2026}
                  target="_blank"
                  rel="noopener noreferrer"
                  download
                >
                  Download
                </a>
              </div>
            </div>
            {/* <div className="container mt-5">
              <img src={mediakit} className="img-fluid" alt="mediakit" />
              <div className="d-flex justify-content-center mt-4">
                <a
                  class="link-btn-green"
                  href={trimaxmediakit}
                  target="_blank"
                  rel="noopener noreferrer"
                  download
                >
                  Download
                </a>
              </div>
            </div> */}
            {/* <div className="container mt-5">
              <img src={mobilekit} className="img-fluid" alt="mediakit" />
              <div className="d-flex justify-content-center mt-4">
                <a
                  class="link-btn-green"
                  href={trimaxmobilekit}
                  target="_blank"
                  rel="noopener noreferrer"
                  download
                >
                  Download
                </a>
              </div>
            </div> */}
          </section>
          <section id="about-us">
            <div className="container">
              <div className="row">
                <div className="col-12 service-title-content">
                  <div className="service-content whatwedo text-center">
                    <div className="overlay">
                      <h2 className="section-title custom">ABOUT US</h2>
                      <ul className="section-subtitle custom" style={{ textAlign: 'left', listStyleType: 'disc', paddingLeft: '20px' }}>
                        <li>
                          <span className="font-weight-bold">Industry Leader:</span> Trimex Outdoor is the nation's leading Place-Based and Lunch Truck advertising company, with 40+ years of coast-to-coast experience.
                        </li>
                        <li>
                          <span className="font-weight-bold">Nationwide Reach:</span> Headquartered in California with offices in South Texas and New York, operating a vast U.S. marketing network that connects directly with blue-collar workers, commuters, construction crews, and underserved communities.
                        </li>
                        <li>
                          <span className="font-weight-bold">Trusted Partner:</span> Chosen by major brands and government agencies for customized PSA campaigns, in-store promotions, and hyper-local advertising strategies.
                        </li>
                        <li>
                          <span className="font-weight-bold">High-Impact Formats:</span> Delivers visibility through branded lunch trucks, neighborhood market banners, and real-world placements where audiences live, work, and shop.
                        </li>
                        <li>
                          <span className="font-weight-bold">Prime Retail Locations:</span> Billboard placements at everyday venues such as grocery stores, c-stores, laundromats, salons, restaurants, car washes, markets, and more.
                        </li>
                        <li>
                          <span className="font-weight-bold">Massive Network & Scalability:</span> Over <span className="font-weight-bold">500,000+ locations nationwide</span>, with customized networks ranging from 30 to 5,000 locations, all handled in-house with no third-party vendors.
                        </li>
                        <li>
                          <span className="font-weight-bold">100% Proof of Performance:</span> Provides full POP with store names, addresses, and mapped locations—far exceeding the industry standard of 25%.
                        </li>
                      </ul>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </section>
          {/*<section id="lunch">
						<div className="container">
							<div className="row">
								<div className="col-md-6">
									<div className="lunch-content p-5">
										<h2 className="section-title mb-4 red">
											Lunch Truck Advertising
										</h2>
										<p className="section-p">
											Blue Collar Demo, including those who work in
											construction, manufacturing, on farms and other industrial
											places of employment. The typical lunch truck makes 20
											stops and serves 500 customers every working day.
										</p>
										<p className="section-p mb-4">
											Advertising impressions are developed from traffic during
											drive time between stops with a combined average daily
											effective circulation of (D.E.C.) 9,000 per truck.
										</p>
										<div className="d-flex mt-4">
											<Link
												to="/lunch-truck-advertising"
												className="link-btn"
												title="learn more about lunch truck advertising"
											>
												Read More
											</Link>
										</div>
									</div>
								</div>
								<div className="col-md-6" />
							</div>
						</div>
					</section>*/}
          {/*<section id="storefront">
						<div className="container">
							<div className="row">
								<div className="col text-center">
									<div className="store-content">
										<h2 className="section-title mb-4">
											Storefront Urban and Rural Advertising
										</h2>
										<h3 className="section-subtitle mb-4">
											Trimex Outdoor offers&nbsp;Urban – Rural Neighborhood
											Advertising&nbsp;with the biggest impact at the lowest
											rates!
											<br />
										</h3>
										<p className="section-p">
											We offer custom showings targeting all types of industries
											and demographics, including Hispanic, Asian, AA,
											Millennials, General Market, Hipsters, Teens, Expecting
											Mothers, Construction Workers, Public Servants and more.…
										</p>
										<div className="d-flex justify-content-center mt-4">
											<Link
												to="/storefront-urban-rural-advertising"
												className="link-btn"
												title="learn more about storefront urban rural advertising"
											>
												Read More
											</Link>
										</div>
									</div>
								</div>
							</div>
						</div>
					</section>*/}
          <section id="clients">
            <div className="container-fluid">
              <div className="row">
                <div className="col">
                  <div className="clients-content">
                    <h2 className="section-title text-center mb-5">
                      Our Clients
                    </h2>
                    <div className="swiper-content">
                      <Partners />
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </section>
          <Contact />
        </div>
      </Layout>
    )
  }
}
export default IndexPage

export const indexPageQuery = graphql`
  query indexPageQuery {
    site {
      siteMetadata {
        title
        googleverification
        meta {
          description
        }
      }
    }
  }
`
